import React, { useEffect, useState } from 'react';
import { Snackbar, Alert, Button, Stack, Box } from '@mui/material';
import { GetApp, Close } from '@mui/icons-material';

/**
 * Listens for the beforeinstallprompt event and shows a "Install app" snackbar.
 * On iOS (which doesn't fire beforeinstallprompt), shows a one-time tip when the
 * page is opened in mobile Safari but not yet in standalone mode.
 */
export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow]         = useState(false);
  const [iosTip, setIosTip]     = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem('pwa_install_dismissed');
    if (dismissed) return;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);

    // iOS Safari fallback — no install prompt API; show a one-time tip
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isIOS && !isStandalone) setIosTip(true);

    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch {}
    setDeferred(null);
    setShow(false);
    localStorage.setItem('pwa_install_dismissed', '1');
  };

  const dismiss = () => {
    setShow(false); setIosTip(false);
    localStorage.setItem('pwa_install_dismissed', '1');
  };

  if (show && deferred) {
    return (
      <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ mb: { xs: 2, md: 3 } }}>
        <Alert severity="info" variant="filled" icon={<GetApp />}
          sx={{ alignItems: 'center', borderRadius: 2 }}
          action={
            <Stack direction="row" spacing={0.5}>
              <Button size="small" color="inherit" onClick={install} sx={{ fontWeight: 700 }}>Install</Button>
              <Button size="small" color="inherit" onClick={dismiss}><Close fontSize="small" /></Button>
            </Stack>
          }>
          <Box sx={{ pr: 1 }}>Install Identium FX as an app for faster access.</Box>
        </Alert>
      </Snackbar>
    );
  }

  if (iosTip) {
    return (
      <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} sx={{ mb: { xs: 2, md: 3 } }}>
        <Alert severity="info" variant="filled" icon={<GetApp />}
          sx={{ alignItems: 'center', borderRadius: 2 }}
          action={<Button size="small" color="inherit" onClick={dismiss}><Close fontSize="small" /></Button>}>
          <Box sx={{ pr: 1, fontSize: 13 }}>
            To install: tap <strong>Share</strong> → <strong>Add to Home Screen</strong>.
          </Box>
        </Alert>
      </Snackbar>
    );
  }

  return null;
}
